module.exports = __webpack_public_path__ + "static/media/BLUSH_4562.08d1bd2f.jpg";